<template>
  <div>
    {{ getDefaultData() }}
  </div>
</template>

<script>
export default {
  name: 'DefaultEventRenderer',
  props: {
    eventType: {
      type: String,
      required: true,
    },
    eventData: {
      type: String,
      required: true,
    }
  },
  methods: {
    getDefaultData() {
        return this.eventData;
    }
  }
};
</script>